(() => {
  const configNode = document.getElementById('lo-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const cutoffHour = Number(config.cutoffHour);
  if (!Number.isInteger(cutoffHour) || cutoffHour < 0 || cutoffHour > 23) return;
  const clock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', hourCycle: 'h23'
  });
  const dateLabel = new Intl.DateTimeFormat(config.locale || 'en', {
    timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
  });
  function refresh() {
    const parts = Object.fromEntries(clock.formatToParts(new Date()).map(part => [part.type, part.value]));
    const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1,
      Number(parts.day) + (Number(parts.hour) < cutoffHour ? 1 : 2)));
    const iso = date.toISOString().slice(0, 10);
    document.querySelectorAll('[data-delivery-estimate]').forEach(node => {
      const time = node.querySelector('time');
      if (time.dateTime !== iso) {
        time.dateTime = iso;
        time.textContent = dateLabel.format(date);
      }
      node.hidden = false;
    });
  }
  document.addEventListener('lo:cart-rendered', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  setInterval(() => { if (!document.hidden) refresh(); }, 1000);
  refresh();
})();
